const { id, log, delay } = require("../std/index")


//
// Background Video
//
// NOTE: Seeking (and therefore looping) can fail on chrome due to PHP Server not
// supporting 206 Partial Content. Should still work on a real apache server.
//

module.exports = class BackgroundVideoWidget {
  constructor($host, config) {
    this.dom = {
      video: $('video', $host),
      button: $('button', $host)
    };

    this.video = this.dom.video[0];

    if (config.autoplay) this.playSelf();
    if (config.mute) this.muteSelf();
    if (config.loop) this.loopSelf();

    // this.video.addEventListener('timeupdate', () => {
    //   log(Math.round(this.video.currentTime / this.video.duration * 100));
    // });
  }

  isHidden() {
    return $(this.video).is(':hidden');
  }

  play() {
    this.video.currentTime = 1;
    delay(10, () => this.video.play());
  }

  playIfVisible() {
    if (!this.isHidden()) this.play();
  }

  playSelf() {
    const onCanPlayThrough = () => {
      this.playIfVisible();
      this.video.removeEventListener('canplaythrough', onCanPlayThrough);
    };
    this.video.addEventListener('canplaythrough', onCanPlayThrough);
  }

  loopSelf() {
    this.video.addEventListener('ended', () => {
      this.play();
    });
  }

  muteSelf() {
    this.video.volume = 0;
  }
};
